"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableBody = TableBody;
/* eslint-disable @typescript-eslint/no-explicit-any */
const react_1 = __importDefault(require("react"));
const react_table_1 = require("@tanstack/react-table");
const classnames_1 = __importDefault(require("classnames"));
const tableBody_css_1 = require("./tableBody.css");
const tableUtils_1 = require("../../utils/tableUtils");
function TableBody({ table, isReady, expandedRowComponent, }) {
    const ExpandedComponent = expandedRowComponent !== null && expandedRowComponent !== void 0 ? expandedRowComponent : (() => null);
    const tableRowClassName = (rowIsExpanded) => (0, classnames_1.default)({ [tableBody_css_1.tableRow]: true, [tableBody_css_1.rowExpanded]: rowIsExpanded });
    return (react_1.default.createElement("tbody", null, table.getRowModel().rows.map((row) => (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("tr", { key: row.id, className: tableRowClassName(row.getIsExpanded()) }, row.getVisibleCells().map((cell) => (react_1.default.createElement("td", { key: cell.id, className: tableBody_css_1.tableData, style: Object.assign({}, (0, tableUtils_1.getCommonPinningStyles)(cell.column, isReady)) }, (0, react_table_1.flexRender)(cell.column.columnDef.cell, cell.getContext()))))),
        row.getIsExpanded() && (react_1.default.createElement("tr", { className: tableBody_css_1.subRow },
            react_1.default.createElement("td", { colSpan: row.getVisibleCells().length },
                react_1.default.createElement(ExpandedComponent, { parentRowData: row.original })))))))));
}
